module.exports = __webpack_public_path__ + "static/media/allLocationsUSfirst.fb2fd471.csv";